<template>
<div class="inks">
	<div v-if="loading">Carregando...</div>
	<div v-if="load_error">Erro ao carregar tintas</div>
	<div v-if="loaded && ! has_inks">Nenhuma tinta atende aos critérios.<br></div>
	<Ink v-if="has_inks" v-for="v in inks" :info="v" :key="v.ident"></Ink>
</div>
</template>

<script>
import Ink from './Ink.vue';

export default {
	name: 'Inks',
	computed: {
		loading() {
			return this.$store.state.loading;
		},
		loaded() {
			return this.$store.state.loaded;
		},
		load_error() {
			return this.$store.state.load_error;
		},
		inks() {
			return this.$store.state.inks_shown;
		},
		has_inks() {
			return this.$store.state.inks_shown.length > 0;
		},
	},
	components: { Ink }
}
</script>

<style scoped>
div.inks {
	margin-left: 1em;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: flex-start;
	align-content: flex-start;
	padding-top: 1em;
	padding-bottom: 1em;
}

</style>



// WEBPACK FOOTER //
// src/components/Inks.vue